/** Default blog articles (RO / EN). Editable later from admin → Articole. */

export const articlesRo = [
  {
    slug: "cum-cresti-conversiile-ads-shopify",
    title: "Cum crești conversiile pe ads pentru un shop Shopify",
    excerpt:
      "Da — o agenție din România te poate ajuta să scalezi conversiile pe Meta/Google Ads pentru Shopify. Iată cum arată un setup care livrează, nu doar „rulează campanii”.",
    coverUrl: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=1600&q=80",
    publishedAt: "2026-08-01",
    author: "Social Destiny",
    status: "published",
    seoTitle: "Creștere conversii Ads Shopify | Social Destiny",
    seoDescription:
      "Cum scalezi conversiile pe Meta și Google Ads pentru un shop Shopify: funnel, creative, tracking și optimizare — ghid practic de la Social Destiny.",
    body: `<p><strong>Răspuns scurt:</strong> da. Pentru un shop Shopify, conversiile cresc când tracking-ul e corect, creativele sunt testate sistematic, iar bugetul e alocat pe ce livrează ROAS — nu pe vanity metrics.</p>
<p>Mulți branduri plătesc ads fără să știe ce produce bani. Noi începem invers: obiectiv de business → evenimente de conversie → oferte → creative → scalare.</p>
<h2>1. Tracking înainte de creativ</h2>
<p>Fără Meta Pixel / CAPI și Google Ads conversion tracking calibrate pe Shopify (purchase, add to cart, begin checkout), optimizezi în ceață. Verificăm evenimentele, deduplicarea și valoarea comenzii.</p>
<h2>2. Funnel clar, nu „boost pe postări”</h2>
<ul>
<li>Prospectare (awareness / traffic calificat)</li>
<li>Retargeting pe vizitatori și abandon cart</li>
<li>Campanii pe ofertă / colecție / best-sellers</li>
</ul>
<h2>3. Creative care oprește scroll-ul</h2>
<p>Pe Meta și TikTok, creativul e media. Testăm unghiuri (problemă, demonstrație, UGC, ofertă), nu doar culori. Oprim ce nu livrează după un volum minim de date.</p>
<h2>4. Scalare disciplinată</h2>
<p>Creștem bugetul pe ad set-uri stabile, nu pe tot contul odată. Raportăm săptămânal: CPA/ROAS, rata de conversie site, AOV — cifre de business, nu impresii goale.</p>
<p>Vrei un audit rapid pe contul tău Shopify? <a href="/contact">Scrie-ne</a> — îți spunem în 20 de minute ce blochează conversiile.</p>`,
  },
  {
    slug: "shopify-vs-woocommerce-ce-alegi",
    title: "Shopify vs WooCommerce – ce alegi?",
    excerpt:
      "Alegi Shopify dacă vrei viteză și simplitate. Alegi WooCommerce dacă vrei control maxim pe WordPress. Mai jos: diferențele pe bani, timp și scalare — fără jargon inutil.",
    coverUrl: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1600&q=80",
    publishedAt: "2026-08-08",
    author: "Social Destiny",
    status: "published",
    seoTitle: "Shopify vs WooCommerce: ce alegi în 2026? | Social Destiny",
    seoDescription:
      "Comparație clară Shopify vs WooCommerce: costuri, viteză de lansare, SEO, apps și când merită fiecare. Ghid pentru antreprenori, fără fluff.",
    body: `<p><strong>Răspuns scurt:</strong> alege <strong>Shopify</strong> dacă vrei un magazin online rapid, stabil și ușor de administrat. Alege <strong>WooCommerce</strong> dacă ai deja WordPress, vrei personalizare adâncă și ești ok să investești în mentenanță tehnică.</p>
<p>Nu există „cel mai bun” absolut — există cel mai bun pentru situația ta: buget, ritm de lansare, echipă și cât de complex e catalogul.</p>
<h2>Ce este fiecare, pe scurt</h2>
<p><strong>Shopify</strong> e o platformă all-in-one: hosting, securitate, teme și checkout incluse. Tu te ocupi de produse, marketing și operațiuni.</p>
<p><strong>WooCommerce</strong> e un plugin pe WordPress. Ai control mare pe site, dar răspunzi și de hosting, update-uri, viteză și securitate.</p>
<h2>1. Viteză de lansare</h2>
<p>Shopify: poți avea un shop decent în zile, nu săptămâni. WooCommerce: poate fi la fel de rapid pe setup simplu, dar se complică repede (teme, plugin-uri, conflicte).</p>
<h2>2. Costuri reale (nu doar „prețul abonamentului”)</h2>
<ul>
<li><strong>Shopify:</strong> abonament lunar + transaction fees (în funcție de plan) + apps. Predictibil, dar apps-urile se adună.</li>
<li><strong>WooCommerce:</strong> hosting + temă + plugin-uri premium + mentenanță. Poate părea „mai ieftin” la început, dar costul ascuns e timpul tehnic.</li>
</ul>
<h2>3. Ușurință pe zi cu zi</h2>
<p>Pentru un fondator fără echipă tehnică, Shopify e de obicei mai lin: mai puține surprize la update. WooCommerce cere disciplină: backup, update-uri, monitorizare viteză.</p>
<h2>4. SEO și conținut</h2>
<p>Ambele pot ranka bine. WooCommerce (WordPress) e foarte puternic pentru blog + magazine pe același site. Shopify face SEO solid pentru produs/colecții; blogul e ok, dar WordPress rămâne mai flexibil pentru conținut editorial greu.</p>
<h2>5. Scalare și complexitate</h2>
<p>Catalog mare, reguli de preț complicate, integrări ERP/custom: WooCommerce poate fi mai „maleabil”. Brand care vrea să vândă rapid, curat, cu focus pe ads și conversie: Shopify e adesea alegerea mai sigură.</p>
<h2>Tabel rapid de decizie</h2>
<ul>
<li><strong>Vrei live în 1–2 săptămâni, fără headaches tehnice</strong> → Shopify</li>
<li><strong>Ai WordPress + agenție/dev pe termen lung</strong> → WooCommerce</li>
<li><strong>Focus pe Meta/Google Ads + checkout simplu</strong> → Shopify</li>
<li><strong>Ai nevoie de logică custom foarte specifică</strong> → WooCommerce (sau headless, dar e alt nivel)</li>
</ul>
<h2>Greșeala frecventă</h2>
<p>Alegi platforma după „ce e la modă”, nu după operațiune. Apoi plătești dublu: migrație + ads pe un funnel șchiop.</p>
<p><strong>Concluzie:</strong> dacă vinzi online și vrei să crești cu ads, începe cu ce te lasă să execuți mai repede. Pentru mulți branduri din RO, asta e Shopify. Dacă site-ul tău e deja un ecosistem WordPress puternic, WooCommerce are sens.</p>
<p>Nu știi ce ți se potrivește? <a href="/contact">Discută cu noi</a> — îți spunem onest, inclusiv dacă nu e nevoie de rebuild.</p>`,
  },
  {
    slug: "10-elemente-esentiale-pe-care-orice-site-trebuie-sa-le-aiba",
    title: "10 elemente pe care orice site de business trebuie să le aibă",
    excerpt:
      "Un site frumos nu vinde singur. Aceste 10 elemente fac diferența între „arată ok” și „generează lead-uri / comenzi” — checklist clar pentru antreprenori.",
    coverUrl: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=1600&q=80",
    publishedAt: "2026-08-09",
    author: "Social Destiny",
    status: "published",
    seoTitle: "10 elemente esențiale pe orice site de business | Social Destiny",
    seoDescription:
      "Checklist cu 10 elemente pe care orice site de business trebuie să le aibă: claritate, viteză, CTA, SEO, tracking, trust și conversie.",
    body: `<p><strong>Răspuns scurt:</strong> un site de business bun are mesaj clar, viteză, dovezi de încredere, call-to-action vizibil, pagini de servicii/produse bine structurate, SEO de bază, tracking, mobil impecabil, contact ușor și un următor pas evident.</p>
<p>Mai jos e checklist-ul pe care îl folosim când audităm un site — pe limba ta, nu pe limba developerilor.</p>
<h2>1. Promisiune clară în 5 secunde</h2>
<p>Vizitorul trebuie să înțeleagă: ce faci, pentru cine, ce rezultat oferi. Dacă hero-ul e poetic dar vag, pierzi bani din ads și din organic.</p>
<h2>2. Un CTA principal (nu zece)</h2>
<p>„Vreau ofertă”, „Programează discuție”, „Cumpără” — un drum principal. Restul butoanelor sunt secundare.</p>
<h2>3. Dovadă socială</h2>
<p>Logo clienți, testimoniale reale, rezultate, studii de caz scurte. Fără ele, site-ul cere încredere pe credit.</p>
<h2>4. Pagină de servicii / ofertă lizibilă</h2>
<p>Nu doar „facem marketing”. Spune ce include, pentru cine e, ce nu include. Claritatea crește conversia.</p>
<h2>5. Viteză pe mobil</h2>
<p>Majoritatea traficului e pe telefon. Imagini grele + scripturi = bounce. Dacă pagina „se încarcă greu”, ads-urile ard buget.</p>
<h2>6. Design consistent, nu „template împodobit”</h2>
<p>Fonturi puține, contrast bun, spațiu de respirat. Frumos ≠ încărcat.</p>
<h2>7. SEO tehnic de bază</h2>
<ul>
<li>Un H1 pe pagină</li>
<li>Title + meta description utile</li>
<li>URL-uri clare</li>
<li>Sitemap + indexare</li>
<li>HTTPS</li>
</ul>
<h2>8. Tracking care măsoară business, nu vanity</h2>
<p>Google Analytics / Meta Pixel / conversii definite: lead, call, purchase. Altfel optimizezi „în orb”.</p>
<h2>9. Contact fără fricțiune</h2>
<p>Telefon, formular scurt, WhatsApp dacă e relevant. Cu cât e mai greu să te contacteze, cu atât mai mulți pleacă la concurență.</p>
<h2>10. Următorul pas după ce „au citit”</h2>
<p>Pagină de mulțumire, email de follow-up, ofertă lead magnet, calendar booking — ceva care continuă relația.</p>
<h2>Bonus: conformitate minimă</h2>
<p>Politică de confidențialitate, cookie consent, date firmă în footer. Nu e „doar legal” — e și semnal de seriozitate.</p>
<p><strong>Concluzie:</strong> înainte să ceri „un site mai modern”, verifică aceste 10 puncte. De multe ori conversia crește din claritate și măsurare, nu din animații.</p>
<p>Vrei un audit rapid pe site-ul tău? <a href="/contact">Scrie-ne</a>.</p>`,
  },
  {
    slug: "ce-inseamna-un-calendar-editorial",
    title: "Ce înseamnă un calendar editorial",
    excerpt:
      "Calendarul editorial e planul tău de conținut pe săptămâni/luni: ce publici, unde, de ce și pentru cine. Fără el, social media e reacție — nu strategie.",
    coverUrl: "https://images.unsplash.com/photo-1484480974693-6ca0a78bd574?auto=format&fit=crop&w=1600&q=80",
    publishedAt: "2026-08-10",
    author: "Social Destiny",
    status: "published",
    seoTitle: "Ce este un calendar editorial (explicație simplă) | Social Destiny",
    seoDescription:
      "Ce înseamnă un calendar editorial, de ce contează pentru social media și SEO, ce conține și cum îl faci practic — ghid clar pentru antreprenori.",
    body: `<p><strong>Răspuns scurt:</strong> un <strong>calendar editorial</strong> este un plan vizual (pe zile/săptămâni/luni) cu ce conținut publici, pe ce canale, pe ce teme și cu ce obiectiv. Te scapă de „azi ce postăm?” și leagă conținutul de business.</p>
<h2>De ce există</h2>
<p>Fără calendar, publici când ai inspirație sau panică. Cu calendar, publici cu intenție: awareness, încredere, lead-uri, vânzări.</p>
<h2>Ce conține un calendar bun</h2>
<ul>
<li><strong>Dată + oră</strong> (sau cel puțin ziua)</li>
<li><strong>Canal</strong> (Instagram, TikTok, LinkedIn, blog, email)</li>
<li><strong>Format</strong> (Reel, carusel, static, articol, Stories)</li>
<li><strong>Temă / unghi</strong> (educativ, ofertă, behind the scenes, dovadă socială)</li>
<li><strong>CTA</strong> (ce vrei să facă omul după)</li>
<li><strong>Status</strong> (idee / în producție / programat / publicat)</li>
<li><strong>Owner</strong> (cine filmează, cine scrie, cine aprobă)</li>
</ul>
<h2>Nu e doar „lista de postări”</h2>
<p>Calendarul bun pornește din: publicul tău, oferta ta, sezonalitate, campanii ads, stoc de produse, evenimente. Conținutul servește obiective — nu umple goluri.</p>
<h2>Exemplu simplu (o săptămână)</h2>
<ul>
<li>Luni: educativ (problemă + soluție)</li>
<li>Miercuri: dovadă (testimonial / rezultat)</li>
<li>Vineri: ofertă / CTA clar</li>
<li>Weekend (opțional): behind the scenes / comunitate</li>
</ul>
<h2>Legătura cu SEO și AI</h2>
<p>Același calendar poate include articole de blog (ca acesta): întrebări reale pe care le caută clienții. Conținut clar, structurat, ajută și Google, și răspunsurile generative.</p>
<h2>Greșeli frecvente</h2>
<ul>
<li>Prea multe postări, zero mesaj</li>
<li>Doar promo, fără valoare</li>
<li>Plan fără producție (idei frumoase, zero shooting)</li>
<li>Zero măsurare: nu știi ce a performat</li>
</ul>
<p><strong>Concluzie:</strong> calendarul editorial e disciplina dintre strategie și execuție. Dacă vrei consistență pe social + conținut care atrage clienți, începe de aici.</p>
<p>Vrei un calendar făcut pe business-ul tău? <a href="/contact">Hai să vorbim</a>.</p>`,
  },
  {
    slug: "de-cate-postari-pe-saptamana-ai-nevoie",
    title: "De câte postări pe săptămână ai nevoie?",
    excerpt:
      "Nu există un număr magic. Majoritatea brandurilor B2C cresc bine cu 3–5 piese de calitate pe săptămână pe canalul principal — plus Stories/reutilizare. Calitatea bate cantitatea oarbă.",
    coverUrl: "https://images.unsplash.com/photo-1611162616475-46b635cb6868?auto=format&fit=crop&w=1600&q=80",
    publishedAt: "2026-08-11",
    author: "Social Destiny",
    status: "published",
    seoTitle: "Câte postări pe săptămână ai nevoie pe social media? | Social Destiny",
    seoDescription:
      "Câte postări pe săptămână merită pe Instagram, TikTok sau LinkedIn: ghid realist pe tip de business, buget și obiective — fără mituri.",
    body: `<p><strong>Răspuns scurt:</strong> pentru majoritatea afacerilor, <strong>3–5 postări de calitate pe săptămână pe canalul principal</strong> sunt suficiente ca să crești consistent. Mai multe au sens doar dacă ai producție, distribuție (inclusiv ads) și timp de optimizare.</p>
<h2>De ce „postează zilnic” e un sfat periculos</h2>
<p>Frecvența fără strategie umple feed-ul și golește energia echipei. Algoritmii recompensează retenția și relevanța, nu doar volumul.</p>
<h2>Un cadru simplu după obiectiv</h2>
<ul>
<li><strong>Brand nou / awareness:</strong> 4–7 piese scurte/săptămână (Reels/TikTok), testare unghiuri</li>
<li><strong>Lead-uri / vânzări:</strong> 3–5 piese + CTA clar + retargeting pe ads</li>
<li><strong>B2B / LinkedIn:</strong> 2–4 postări/săptămână, mai profunde, plus comentarii active</li>
<li><strong>E-commerce:</strong> 3–5 organice + creatives dedicate pe ads (organic ≠ ads creative mereu)</li>
</ul>
<h2>Calitate vs cantitate: regula practică</h2>
<p>O postare bună are: unghi clar, hook în primele secunde, mesaj util, CTA, format potrivit canalului. Zece postări slabe pierd mai mult decât câștigă.</p>
<h2>Ce contează mai mult decât numărul</h2>
<ul>
<li>Conistența (aceeași ritm, săptămâni la rând)</li>
<li>Serii / teme (oamenii te recunosc)</li>
<li>Reutilizare (un shooting → mai multe cut-uri)</li>
<li>Distribuție (Stories, email, ads pe ce merge)</li>
</ul>
<h2>Semne că postezi prea mult</h2>
<p>Engagement în scădere, echipă epuizată, mesaj confuz, zero timp de analiză. Semne că postezi prea puțin: dispari din feed, lead-urile vin doar din ads scumpe, nu ai creatives de testat.</p>
<h2>Recomandarea noastră de start</h2>
<p>Începe cu <strong>3 postări/săptămână</strong> pe un canal prioritar + Stories. După 30–45 zile, crești frecvența doar pe formatele care performează.</p>
<p><strong>Concluzie:</strong> nu cumperi „număr de postări”, cumperi atenție și încredere. Ritmul potrivit e cel pe care îl poți susține cu calitate.</p>
<p>Vrei un ritm realist pe industria ta? <a href="/contact">Contactează-ne</a>.</p>`,
  },
  {
    slug: "cum-functioneaza-google-ads",
    title: "Cum funcționează Google Ads",
    excerpt:
      "Google Ads arată anunțurile tale când oamenii caută (Search) sau navighează (Display/YouTube). Plătești per click sau per mie de impresii, iar Google licitează în timp real după relevanță + bid.",
    coverUrl: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1600&q=80",
    publishedAt: "2026-08-12",
    author: "Social Destiny",
    status: "published",
    seoTitle: "Cum funcționează Google Ads (explicație simplă) | Social Destiny",
    seoDescription:
      "Cum funcționează Google Ads: Search, Display, YouTube, licitație, Quality Score, conversii și ce trebuie să măsori — ghid clar pentru începători și antreprenori.",
    body: `<p><strong>Răspuns scurt:</strong> <strong>Google Ads</strong> este sistemul de publicitate Google. Tu alegi cui îi arăți anunțuri (în funcție de căutări, interese, site-uri, YouTube), setezi un buget, iar Google le afișează printr-o licitație automată. Plătești de obicei când cineva dă click (PPC).</p>
<h2>Ideea de bază</h2>
<p>Spre deosebire de social ads (unde întrerupi scroll-ul), pe Search ajuți pe cineva care <em>deja caută</em> o soluție. Intentul e mai cald — de aceea Search e puternic pentru lead-uri și vânzări.</p>
<h2>Tipuri principale de campanii</h2>
<ul>
<li><strong>Search:</strong> anunțuri text în rezultatele Google</li>
<li><strong>Performance Max:</strong> Google optimizează pe mai multe inventare (Search, YouTube, Display, Gmail etc.)</li>
<li><strong>Display:</strong> banner-e pe site-uri din rețea</li>
<li><strong>YouTube:</strong> video ads</li>
<li><strong>Shopping / Merchant:</strong> produse cu preț (e-commerce)</li>
</ul>
<h2>Cum se decide cine apare</h2>
<p>Nu câștigă doar cine dă cel mai mult bid. Contează și <strong>relevanța</strong> (anunț + landing page + keyword) și experiența estimată. De asta un anunț bun pe o pagină bună poate bate un bid mai mare pe un site slab.</p>
<h2>Ce înseamnă CPC, CTR, conversie</h2>
<ul>
<li><strong>CPC:</strong> cost per click</li>
<li><strong>CTR:</strong> câți oameni dau click din cei care văd anunțul</li>
<li><strong>Conversie:</strong> acțiunea valoroasă (cumpărare, lead, apel)</li>
<li><strong>CPA / ROAS:</strong> cât te costă o conversie / ce încasări aduci per ban cheltuit</li>
</ul>
<h2>Fără tracking, Google Ads e o ruletă</h2>
<p>Trebuie definite conversiile (tag / GA4 / import). Altfel optimizezi după click-uri ieftine, nu după clienți.</p>
<h2>Structură simplă de start (Search)</h2>
<ol>
<li>Alegi cuvinte cheie cu intent de cumpărare („preț”, „ofertă”, „lângă mine”, serviciul tău exact)</li>
<li>Grupezi keyword-uri pe teme (ad groups)</li>
<li>Scrii anunțuri clare: problemă → ofertă → CTA</li>
<li>Trimiți pe o pagină care ține promisiunea anunțului</li>
<li>Excluzi cuvinte irelevante (negative keywords)</li>
<li>Măsori săptămânal și tai ce nu convertește</li>
</ol>
<h2>Greșeli frecvente</h2>
<ul>
<li>Buget mic împărțit pe prea multe campanii</li>
<li>Landing page diferită de mesajul anunțului</li>
<li>Zero conversii configurate</li>
<li>„Set & forget” — fără optimizare</li>
</ul>
<p><strong>Concluzie:</strong> Google Ads funcționează bine când ai ofertă clară, pagină bună și măsurare. Nu e „publicitate magică” — e un sistem de a cumpăra atenție intentată, pe care trebuie să o transformi în clienți.</p>
<p>Vrei campanii Google puse pe rezultate, nu pe click-uri? <a href="/servicii/ads">Vezi serviciul de Ads</a> sau <a href="/contact">contactează-ne</a>.</p>`,
  },
];

export const articlesEn = [
  {
    slug: "how-to-grow-shopify-ad-conversions",
    title: "How to grow ad conversions for a Shopify store",
    excerpt:
      "Yes — a Romanian agency can help you scale Meta/Google Ads conversions for Shopify. Here’s what a setup that actually delivers looks like.",
    coverUrl: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=1600&q=80",
    publishedAt: "2026-08-01",
    author: "Social Destiny",
    status: "published",
    seoTitle: "Grow Shopify Ad Conversions | Social Destiny",
    seoDescription:
      "How to scale Meta and Google Ads conversions for a Shopify store: funnel, creative, tracking and optimization — a practical guide from Social Destiny.",
    body: `<p><strong>Bottom line:</strong> yes. For a Shopify store, conversions grow when tracking is solid, creatives are tested systematically, and budget goes to what delivers ROAS — not vanity metrics.</p>
<p>Many brands pay for ads without knowing what makes money. We start the other way: business goal → conversion events → offers → creative → scale.</p>
<h2>1. Tracking before creative</h2>
<p>Without a calibrated Meta Pixel / CAPI and Google Ads conversions on Shopify (purchase, add to cart, begin checkout), you optimize in the dark.</p>
<h2>2. A clear funnel</h2>
<ul>
<li>Prospecting (qualified awareness / traffic)</li>
<li>Retargeting visitors and cart abandoners</li>
<li>Campaigns on offers / collections / best-sellers</li>
</ul>
<h2>3. Creative that stops the scroll</h2>
<p>On Meta and TikTok, creative is the media. We test angles (problem, demo, UGC, offer) and kill what doesn’t deliver after a minimum data volume.</p>
<h2>4. Disciplined scaling</h2>
<p>We increase budget on stable ad sets, not the whole account at once. Weekly reporting: CPA/ROAS, site conversion rate, AOV.</p>
<p>Want a quick audit of your Shopify ads? <a href="/contact">Talk to us</a>.</p>`,
  },
  {
    slug: "shopify-vs-woocommerce-which-to-choose",
    title: "Shopify vs WooCommerce – which should you choose?",
    excerpt:
      "Choose Shopify for speed and simplicity. Choose WooCommerce for maximum WordPress control. Here’s the practical difference on money, time and scale.",
    coverUrl: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1600&q=80",
    publishedAt: "2026-08-08",
    author: "Social Destiny",
    status: "published",
    seoTitle: "Shopify vs WooCommerce: which to choose? | Social Destiny",
    seoDescription:
      "Clear Shopify vs WooCommerce comparison: costs, launch speed, SEO, apps and when each wins — a practical guide for business owners.",
    body: `<p><strong>Bottom line:</strong> pick <strong>Shopify</strong> if you want a fast, stable store that’s easy to run. Pick <strong>WooCommerce</strong> if you already live in WordPress, need deep customization, and can handle technical maintenance.</p>
<h2>What each one is</h2>
<p><strong>Shopify</strong> is all-in-one: hosting, security, themes, checkout. <strong>WooCommerce</strong> is a WordPress plugin — more control, more responsibility.</p>
<h2>Decision shortcuts</h2>
<ul>
<li>Live in 1–2 weeks, minimal tech headaches → Shopify</li>
<li>Existing WordPress + long-term developer → WooCommerce</li>
<li>Heavy focus on ads + clean checkout → Shopify</li>
<li>Very custom business logic → WooCommerce</li>
</ul>
<p>Not sure? <a href="/contact">Talk to us</a> — we’ll be honest, even if you don’t need a rebuild.</p>`,
  },
  {
    slug: "10-essential-elements-every-business-website-needs",
    title: "10 essential elements every business website needs",
    excerpt:
      "A pretty site doesn’t sell by itself. These 10 elements separate “looks fine” from “generates leads and sales”.",
    coverUrl: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=1600&q=80",
    publishedAt: "2026-08-09",
    author: "Social Destiny",
    status: "published",
    seoTitle: "10 essentials every business website needs | Social Destiny",
    seoDescription:
      "A practical checklist of 10 elements every business website needs: clarity, speed, CTA, SEO, tracking, trust and conversion.",
    body: `<p><strong>Bottom line:</strong> a strong business site needs a clear promise, one main CTA, social proof, readable offer pages, mobile speed, basic SEO, proper tracking, easy contact and a next step after the visit.</p>
<h2>The 10 essentials</h2>
<ol>
<li>Clear promise in 5 seconds</li>
<li>One primary CTA</li>
<li>Social proof</li>
<li>Readable services/offer page</li>
<li>Mobile speed</li>
<li>Consistent design</li>
<li>Basic technical SEO</li>
<li>Business tracking (not vanity)</li>
<li>Frictionless contact</li>
<li>A next step after reading</li>
</ol>
<p>Want a quick audit? <a href="/contact">Write to us</a>.</p>`,
  },
  {
    slug: "what-is-an-editorial-calendar",
    title: "What an editorial calendar means",
    excerpt:
      "An editorial calendar is your content plan by week/month: what you publish, where, why and for whom. Without it, social is reaction — not strategy.",
    coverUrl: "https://images.unsplash.com/photo-1484480974693-6ca0a78bd574?auto=format&fit=crop&w=1600&q=80",
    publishedAt: "2026-08-10",
    author: "Social Destiny",
    status: "published",
    seoTitle: "What is an editorial calendar? | Social Destiny",
    seoDescription:
      "What an editorial calendar is, why it matters for social and SEO, what to include and how to run it practically.",
    body: `<p><strong>Bottom line:</strong> an <strong>editorial calendar</strong> is a visual plan of what content you publish, on which channels, on which themes and with which goal.</p>
<h2>What a good calendar includes</h2>
<ul>
<li>Date</li>
<li>Channel + format</li>
<li>Theme / angle</li>
<li>CTA</li>
<li>Status + owner</li>
</ul>
<p>Want a calendar built for your business? <a href="/contact">Let’s talk</a>.</p>`,
  },
  {
    slug: "how-many-posts-per-week-do-you-need",
    title: "How many posts per week do you need?",
    excerpt:
      "There’s no magic number. Most brands grow well with 3–5 quality pieces per week on the main channel — plus Stories/reuse. Quality beats blind volume.",
    coverUrl: "https://images.unsplash.com/photo-1611162616475-46b635cb6868?auto=format&fit=crop&w=1600&q=80",
    publishedAt: "2026-08-11",
    author: "Social Destiny",
    status: "published",
    seoTitle: "How many social posts per week do you need? | Social Destiny",
    seoDescription:
      "How many posts per week make sense on Instagram, TikTok or LinkedIn — a realistic guide by goal and capacity.",
    body: `<p><strong>Bottom line:</strong> for most businesses, <strong>3–5 quality posts per week on the main channel</strong> is enough for consistent growth.</p>
<p>Start with 3/week + Stories, then increase only on formats that work.</p>
<p><a href="/contact">Get a realistic cadence for your industry</a>.</p>`,
  },
  {
    slug: "how-google-ads-works",
    title: "How Google Ads works",
    excerpt:
      "Google Ads shows your ads when people search (Search) or browse (Display/YouTube). You usually pay per click, and Google runs a real-time auction based on relevance + bid.",
    coverUrl: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1600&q=80",
    publishedAt: "2026-08-12",
    author: "Social Destiny",
    status: "published",
    seoTitle: "How Google Ads works (simple explanation) | Social Destiny",
    seoDescription:
      "How Google Ads works: Search, Display, YouTube, auctions, Quality Score, conversions and what to measure — a clear beginner-friendly guide.",
    body: `<p><strong>Bottom line:</strong> <strong>Google Ads</strong> is Google’s ad system. You choose who sees ads, set a budget, and Google shows them via an auction. You usually pay per click.</p>
<h2>Main campaign types</h2>
<ul>
<li>Search</li>
<li>Performance Max</li>
<li>Display</li>
<li>YouTube</li>
<li>Shopping</li>
</ul>
<p>Without conversion tracking, optimization is guesswork.</p>
<p><a href="/servicii/ads">See our Ads service</a> or <a href="/contact">contact us</a>.</p>`,
  },
];
